export default "__VITE_ASSET__zabv6Ur$__"